import InfoItem from '@components/Home/InfoItem/InfoItem'
import { Stack } from '@mui/material'
import React from 'react'
import './ServiceItem.scss'
import {
  StackImage,
  StackServiceItem,
} from '@components/Home/ServiceItem/ServiceItem.style'

const ServiceItem = ({
  title,
  description,
  icon,
  imgService,
  isWithImg,
  isService,
}) => {
  return (
    <StackServiceItem
      className='service-item-stack'
      isWithImg={isWithImg}
      style={{
        padding: isWithImg ? '2rem 0rem 0rem 2rem' : '2rem',
      }}
    >
      <InfoItem
        title={title}
        description={description}
        img={icon}
        isWithImg={isWithImg}
        isService={isService}
      />
      {imgService && (
        <StackImage className='stack-img' isWithImg={isWithImg}>
          <img src={imgService} alt={title} className='img img-fluid' />
        </StackImage>
      )}
    </StackServiceItem>
  )
}

export default ServiceItem
